import { Image } from "@chakra-ui/react";

export default function Footer(){
    return (
      
            <Image src="https://i.postimg.cc/GmXMJQzH/Capture2.jpg" margin="auto" width="80%" height="400px"/>
        
    )
}